import { getField, updateField } from "vuex-map-fields";
import mutations from "./mutations"
import * as actions from "./actions"
export default {
    namespaced: true,
    state: {
        isLoading: false,
        items: [],
        showMessage: false,
        message: "",
        isSuccess: false,
        currentItem: null,
        pagination:{}


    },
    actions,
    getters: {
        getField,

    },
    mutations: {
        updateField,
        ...mutations,
    },
}


// {
//     field: 'actions', title: 'Actions', hide: false, cellRenderer: () => {
//         return ` `
//     }
// },